import React from "react";
import { Link } from "react-router-dom";
import { SignedIn, SignedOut } from "@clerk/clerk-react";

export default function PublicNav({ active }) {
  const linkClass = (key) =>
    `text-sm font-medium transition-colors ${
      active === key ? "text-rouge" : "text-ink/60 hover:text-ink"
    }`;

  return (
    <header className="border-b border-line bg-paper/80 backdrop-blur-md sticky top-0 z-30">
      <div className="max-w-5xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-8 h-8 bg-rouge rounded-lg flex items-center justify-center shadow-rouge">
            <span className="text-white font-bold text-sm font-display">V</span>
          </div>
          <span className="text-lg font-display font-semibold text-ink tracking-tight">
            MmeValentine
          </span>
        </Link>

        <nav className="hidden sm:flex items-center gap-6">
          <Link to="/pricing" className={linkClass("pricing")}>
            Tarifs
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <SignedOut>
            <Link to="/login" className="text-sm font-medium text-ink/60 hover:text-ink">
              Connexion
            </Link>
            <Link to="/register" className="btn-primary text-sm py-2 px-4">
              Essayer gratuitement
            </Link>
          </SignedOut>
          <SignedIn>
            <Link to="/" className="btn-secondary text-sm py-2 px-4">
              Tableau de bord
            </Link>
          </SignedIn>
        </div>
      </div>
    </header>
  );
}
